throw new Error("File [/metrics/file.ts] is not to be bundled")